/**************************************************
 * Nombre:       Formulario_Escuela_Indicadores_Indicador
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {NumbersOutlined, TitleOutlined} from "@mui/icons-material";

const Formulario_Escuela_Indicadores_Indicador = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={4}>
                    <IngresoTexto Icono={NumbersOutlined} nombre={'Numero del Indicador'}
                                  dato={'numero'} {...props} type={'number'}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={8}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Nombre del Indicador'}
                                  dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Escuela_Indicadores_Indicador